import { Link, NavLink, useMatches } from '@remix-run/react'
import { cn } from '#app/utils/misc.tsx'
import { baseContainerWidthClassList } from '../classlists.tsx'
import { Button } from '../ui/button.tsx'
import { Icon } from '../ui/icon.tsx'
// import { useOptionalUser } from '#app/utils/user.ts'
// import UserDropdown from '../dropdowns/dropdown-user.tsx'
// import ThemeSwitcher from '../theme-switch.tsx'

export function HeaderBase({
	routeAdmin,
	routeLogin,
}: {
	routeAdmin?: boolean
	routeLogin?: boolean
}) {
	// const user = useOptionalUser()
	const headerHeight = 'lg:min-h-[60px]'
	const menuItemClassList = `${headerHeight} relative flex items-center`
	const menuMobileItemClassList = "max-lg:w-[20%] max-lg:justify-center"

	const matches = useMatches()
	const { id } = matches[matches.length - 1]
	const routeIsReservation = id.includes('/reservation')

	return (
		<header className={cn('max-lg:absolute', routeAdmin && 'max-lg:hidden')}>
			<div className="fixed z-1999 w-full max-lg:bottom-1 lg:top-0">
				<div
					className={cn(
						'shadow-header-menu max-lg:mx-1 max-lg:rounded-xl',
						!(routeLogin || routeAdmin) ?
							'bg-black/30 text-white backdrop-blur-md' : "bg-white",
					)}
				>
					<nav
						className={cn(
							'space-between flex items-center justify-between max-lg:px-5',
							baseContainerWidthClassList,
							headerHeight,
						)}
					>
						<Link to="/" className="text-lg font-bold capitalize max-lg:hidden">
							<div>penzion sklář</div>
						</Link>

						<div className="flex items-center justify-center gap-7 max-lg:w-full  lg:gap-12">
							{/* max-lg:justify-around */}
							<MenuItem
								routeTarget="/"
								title="úvod"
								menuItemClassList={`${menuItemClassList} ${menuMobileItemClassList} max-lg:hidden`}
							/>

							<MenuItem
								routeTarget="rooms"
								title="Ubytování"
								iconName="home"
								menuItemClassList={`${menuItemClassList} ${menuMobileItemClassList}`}
							/>
							<MenuItem
								routeTarget="services-and-use"
								title="služby & využití"
								menuItemClassList={`${menuItemClassList} max-lg:hidden`}
							/>
							<MenuItem
								routeTarget="services-and-use"
								title="služby"
								iconName="loop"
								menuItemClassList={`${menuItemClassList} ${menuMobileItemClassList} lg:hidden`}
							/>

							<div className={`lg:hidden mx-2 ${menuMobileItemClassList}`} />

							
							<div className="lg:hidden absolute flex items-center justify-center bottom-1 bg-black rounded-full w-[65px] h-[65px]">
								<Link to="/">
									<Icon size="xl" name="home" className='mr-[.1rem] mb-[.1rem]' />
								</Link>
							</div>
							

							<MenuItem
								routeTarget="gallery"
								title="galerie"
								iconName="dashboard"
								menuItemClassList={`${menuItemClassList} ${menuMobileItemClassList}`}
							/>

							<MenuItem
								routeTarget="contact"
								title="kontakt"
								iconName="envelope-closed"
								menuItemClassList={`${menuItemClassList} ${menuMobileItemClassList}`}
							/>

							<div className={cn(routeIsReservation && "max-lg:hidden" ,"max-lg:absolute max-lg:bottom-16 max-lg:right-2")}>
								<Link prefetch="intent" to="/reservation">
									<Button
										variant="highlight"
										className="px-8 max-lg:h-8 max-lg:px-2"
									>
										Rezervace
									</Button>
								</Link>
							</div>
						</div>
					</nav>
				</div>
			</div>

			<div className={headerHeight} />
		</header>
	)
}

function MenuItem({
	routeTarget,
	title,
	iconName,
	menuItemClassList,
}: {
	routeTarget: string
	title?: string
	iconName?: string
	menuItemClassList: string
}) {
	const titleHolder = title ?? routeTarget

	return (
		<NavLink to={routeTarget} className={menuItemClassList}>
			{({ isActive }) => (
				<>
					<div
						className={cn(
							'capitalize before:absolute before:bottom-0 before:w-full before:rounded-2xl before:border-2 before:transition-all hover:before:border-white max-lg:hidden',
							isActive ? 'before:border-white' : 'before:border-transparent',
						)}
					>
						{titleHolder}
					</div>

					<div className={cn("max-lg:py-2 flex flex-col items-center gap-1 lg:hidden", isActive ? 'before:absolute before:bottom-0 before:w-full before:rounded-2xl before:border-2 before:transition-all hover:before:border-white' : "opacity-80")}>
						<Icon
							size="lg"
							name={iconName ?? "home"}
						/>
						<span className="capitalize text-xs font-bold">{titleHolder}</span>
					</div>
				</>
			)}
		</NavLink>
	)
}
